import axios from 'axios';
import { SportType } from '@/interface/enum';
import type { MemberCenterMyVoucherModelsGetAvailableSportsVouchersRequest, TeraBackendProductApisEntitiesSwitchProductRequest } from '@/interface/tera';
import type { IVoucher, IVoucherResponse } from '@/interface/voucher';
import { SirenProductType, VoucherType } from '@/interface/voucher';
import { createApiInstance } from '@/libraries/apis/createApiInstance';
import {
    getPpApiUrl,
} from '@/libraries/url';

axios.defaults.timeout = 15 * 1000;

function createInstance(baseUrl: string) {
    return createApiInstance({
        baseURL: baseUrl,
        withCredentials: true,
    });
}

const ppApiInstance = createInstance(getPpApiUrl());

export default {
    productSwitch({ product, gameFrom }: TeraBackendProductApisEntitiesSwitchProductRequest) {
        return ppApiInstance.post('/landing/switchProduct', {
            product,
            ...(gameFrom ? { gameFrom } : {}),
        });
    },
    ppWelcome() {
        return ppApiInstance.post('/landing/welcome', {
            product: 'Sports',
        });
    },
    async getAvailableSportsVouchers(sportType: SportType, leagueId: number): Promise<IVoucher[]> {
        const response = await ppApiInstance.post('/promotion/GetAvailableSportsVouchers', {
            sportType: SportType.toPollux(sportType),
            leagueId,
        } as MemberCenterMyVoucherModelsGetAvailableSportsVouchersRequest);
        return formatVoucherResponse(response.data);
    },
    openInJoiGame(gameCode: number, gameFrom: number) {
        return ppApiInstance.post(`/landing/OpenLandingGame?GameCode=${gameCode}&GameFrom=${gameFrom}`, null);
    },
};

function formatVoucherResponse(data: IVoucherResponse[]): IVoucher[] {
    return data.map(voucher => ({
        ...voucher,
        type: VoucherType.Active,
        productType: SirenProductType.SportsBook,
    }));
}
